/**
 * @generated SignedSource<<b3a6398ac642f6a02d14c60ca877ba81>>
 * @relayHash 76542aee6e4003d20e65765e2c0abbf7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 15f73cad5301305479bcbdc47643d8fae8b955d056a05d5b7cf09d43e958c635

import type { ConcreteRequest, Query } from 'relay-runtime';
export type DeploymentState = "CANCELLED" | "FAILED" | "IN_PROGRESS" | "PENDING" | "ROLLED_BACK" | "SUCCESSFUL" | "UNKNOWN" | "%future added value";
export type DevOpsEnvironmentCategory = "DEVELOPMENT" | "PRODUCTION" | "STAGING" | "TESTING" | "UNMAPPED" | "%future added value";
export type mainDeploymentsAGSQuery$variables = {
  after?: string | null | undefined;
  first: number;
  projectId: string;
  timeAfter: AGG$Long;
  timeBefore: AGG$Long;
};
export type mainDeploymentsAGSQuery$data = {
  readonly graphStore: {
    readonly projectAssociatedDeployment: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly deploymentSequenceNumber?: AGG$Long | null | undefined;
          readonly description?: string | null | undefined;
          readonly displayName?: string | null | undefined;
          readonly environment?: {
            readonly category: DevOpsEnvironmentCategory | null | undefined;
            readonly displayName: string | null | undefined;
          } | null | undefined;
          readonly id?: string;
          readonly issueIds?: ReadonlyArray<string> | null | undefined;
          readonly lastUpdated?: AGG$DateTime | null | undefined;
          readonly pipeline?: {
            readonly displayName: string | null | undefined;
            readonly url: string | null | undefined;
          } | null | undefined;
          readonly state?: DeploymentState | null | undefined;
          readonly updateSequenceNumber?: AGG$Long | null | undefined;
          readonly url?: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly endCursor: string | null | undefined;
        readonly hasNextPage: boolean;
      };
    } | null | undefined;
  } | null | undefined;
};
export type mainDeploymentsAGSQuery = {
  response: mainDeploymentsAGSQuery$data;
  variables: mainDeploymentsAGSQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeAfter"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeBefore"
},
v5 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "fields": [
      {
        "items": [
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "greaterThanOrEqual",
                    "variableName": "timeAfter"
                  }
                ],
                "kind": "ObjectValue",
                "name": "to_deploymentLastUpdated"
              }
            ],
            "kind": "ObjectValue",
            "name": "and.0"
          },
          {
            "fields": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "lessThan",
                    "variableName": "timeBefore"
                  }
                ],
                "kind": "ObjectValue",
                "name": "to_deploymentLastUpdated"
              }
            ],
            "kind": "ObjectValue",
            "name": "and.1"
          }
        ],
        "kind": "ListValue",
        "name": "and"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectId"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": {
      "to_deploymentLastUpdated": {
        "direction": "DESC",
        "priority": 1
      }
    }
  }
],
v6 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v9 = {
  "kind": "ScalarField",
  "name": "url"
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    {
      "args": [
        {
          "kind": "Variable",
          "name": "projectId",
          "variableName": "projectId"
        }
      ],
      "kind": "ScalarField",
      "name": "issueIds"
    },
    {
      "kind": "ScalarField",
      "name": "deploymentSequenceNumber"
    },
    {
      "kind": "ScalarField",
      "name": "updateSequenceNumber"
    },
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "state"
    },
    {
      "kind": "ScalarField",
      "name": "lastUpdated"
    },
    {
      "concreteType": "DeploymentPipeline",
      "kind": "LinkedField",
      "name": "pipeline",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        (v8/*: any*/)
      ]
    },
    {
      "concreteType": "DevOpsEnvironment",
      "kind": "LinkedField",
      "name": "environment",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "category"
        },
        (v8/*: any*/)
      ]
    }
  ],
  "type": "DeploymentSummary"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainDeploymentsAGSQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "GraphStoreSimplifiedProjectAssociatedDeploymentConnection",
            "kind": "LinkedField",
            "name": "projectAssociatedDeployment",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "concreteType": "GraphStoreSimplifiedProjectAssociatedDeploymentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainDeploymentsAGSQuery",
    "selections": [
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "GraphStoreSimplifiedProjectAssociatedDeploymentConnection",
            "kind": "LinkedField",
            "name": "projectAssociatedDeployment",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "concreteType": "GraphStoreSimplifiedProjectAssociatedDeploymentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "15f73cad5301305479bcbdc47643d8fae8b955d056a05d5b7cf09d43e958c635",
    "metadata": {},
    "name": "mainDeploymentsAGSQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ac55f8e19c154dac8550b1937dc29436";

export default node;
